
<!-- Neptune Sidebar with collapsible sidebar -->
 <!-- Action center, Overview (Program Hub) and Customer Icons are the old icons
     Will need to replace them once we have the new icons from UX team -->
  <nav class="neptune-sidebar fixed box-border p-3 top-0 left-0 h-full bg-surface-dark shadow-md z-[15] transition-all duration-300 ease-in-out"
    [ngClass]="[
      isCollapsed ? 'w-[80px]' : 'w-[360px]',
      !canNavigateTo(NavigationMenu.CustomerOverview) ? 'pt-16' : ''
    ]">

    <!-- Expand & Collapse Button -->
    <div class="sidebar-header flex items-center p-4 border-b border-white border-opacity-20" [ngClass]="isCollapsed ? 'justify-center' : 'justify-start gap-3'">
      <button
        *ngIf="canShowSidebarControls"
        (click)="toggleSidebar()"
        class="p-0 bg-transparent"
        [attr.aria-label]="isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'">
        <span class="collapse-wrapper flex" *ngIf="!isCollapsed">
          <img src="assets/chevron-left-white.svg" alt="Collapse" class="w-5 h-5"/>
          <span class="pl-4 text-white text-sm collapse-text font-normal">Collapse</span>
        </span>
        <span *ngIf="isCollapsed" class="expand-wrapper flex">
          <img src="assets/chevron-right-white.svg" alt="Expand" class="w-5 h-5"/>
        </span>
      </button>
    </div>

    <!-- Navigation Menu -->
    <div class="nav-menu flex flex-col pt-4">

      <!-- Total Value Delivery -->
      <a
        *ngIf="canNavigateTo(NavigationMenu.TotalValueDelivery)"
        data-id="total-value-delivery"
        [routerLink]="(filters && filters.division == 'Distributor') ? '/total-value-delivery-distributor' : '/total-value-delivery'"
        routerLinkActive
        #tvdLink="routerLinkActive"
        class="neptune-nav-item flex items-center p-4 text-white hover:bg-white hover:bg-opacity-10 transition-colors cursor-pointer"
        [ngClass]="{'justify-center': isCollapsed, 'neptune-nav-active bg-white text-blue': tvdLink.isActive || isRouteActiveGivenKeyword('total-value-delivery')}"
        [attr.title]="isCollapsed ? 'Total Value Delivery' : null">
        <img
          [src]="tvdLink.isActive || isRouteActiveGivenKeyword('total-value-delivery') ? 'assets/tvd-navbar-active.svg' : 'assets/tvd-navbar-inactive.svg'"
          alt="TVD Icon"
          class="w-6 h-6"
          [ngClass]="isCollapsed ? '' : 'mr-3'"
        />
        <span *ngIf="!isCollapsed" class="font-normal text-sm whitespace-nowrap">Total Value Delivery</span>
      </a>

      <!-- Solution Participation -->
      <a
        *ngIf="canNavigateTo(NavigationMenu.SolutionParticipationDetails)"
        data-id="solution-participation-details"
        routerLink="/solution-participation-details"
        routerLinkActive
        #spLink="routerLinkActive"
         class="neptune-nav-item flex items-center p-4 text-white hover:bg-white hover:bg-opacity-10 transition-colors cursor-pointer"
        [ngClass]="{'justify-center': isCollapsed, 'neptune-nav-active bg-white text-blue': spLink.isActive || isRouteActiveGivenKeyword('solution-participation')}"
        [attr.title]="isCollapsed ? 'Solution Participation' : null">
        <img
          [src]="spLink.isActive || isRouteActiveGivenKeyword('solution-participation') ? 'assets/sp-navbar-active.svg' : 'assets/sp-navbar-inactive.svg'"
          alt="SP Icon"
          class="w-6 h-6"
          [ngClass]="isCollapsed ? '' : 'mr-3'"
        />
        <span *ngIf="!isCollapsed" class="font-normal text-sm whitespace-nowrap">Solution Participation</span>
      </a>

      <!-- Service Insights -->
      <a
        *ngIf="canNavigateTo(NavigationMenu.ServiceInsights)"
        data-id="service-insights"
        routerLink="/service-insights"
        routerLinkActive
        #siLink="routerLinkActive"
        class="neptune-nav-item flex items-center p-4 text-white hover:bg-white hover:bg-opacity-10 transition-colors cursor-pointer"
        [ngClass]="{'justify-center': isCollapsed, 'neptune-nav-active bg-white text-blue': siLink.isActive || isRouteActiveGivenKeyword('service-insights')}"
        [attr.title]="isCollapsed ? 'Service Insights' : null">
        <img
          [src]="siLink.isActive || isRouteActiveGivenKeyword('service-insights') ? 'assets/si-navbar-active.svg' : 'assets/si-navbar-inactive.svg'"
          alt="SI Icon"
          class="w-6 h-6"
          [ngClass]="isCollapsed ? '' : 'mr-3'"
        />
        <span *ngIf="!isCollapsed" class="font-normal text-sm whitespace-nowrap">Service Insights</span>
      </a>

      <!-- SMARTPOWER Summary -->
      <a
        *ngIf="canNavigateTo(NavigationMenu.SmartPower)"
        data-id="smartpower"
        routerLink="/smartpower"
        routerLinkActive
        #smpLink="routerLinkActive"
        class="neptune-nav-item flex items-center p-4 text-white hover:bg-white hover:bg-opacity-10 transition-colors cursor-pointer"
        [ngClass]="{'justify-center': isCollapsed, 'neptune-nav-active bg-white text-blue': smpLink.isActive || isRouteActiveGivenKeyword('smartpower')}"
        [attr.title]="isCollapsed ? 'SMARTPOWER Summary' : null">
        <img
          [src]="smpLink.isActive || isRouteActiveGivenKeyword('smartpower') ? 'assets/smp-navbar-active.svg' : 'assets/smp-navbar-inactive.svg'"
          alt="SmartPower Icon"
          class="w-6 h-6"
          [ngClass]="isCollapsed ? '' : 'mr-3'"
        />
        <span *ngIf="!isCollapsed" class="font-normal text-sm whitespace-nowrap">SMARTPOWER Summary</span>
      </a>

      <!-- Action Center -->
      <a
        *ngIf="canNavigateTo(NavigationMenu.ActionCenter)"
        id="action-center"
        data-id="action-center"
        routerLink="/action-center"
        routerLinkActive
        #acLink="routerLinkActive"
        class="neptune-nav-item flex items-center p-4 text-white hover:bg-white hover:bg-opacity-10 transition-colors cursor-pointer"
        [ngClass]="{'justify-center': isCollapsed, 'neptune-nav-active bg-white text-blue': acLink.isActive || isRouteActiveGivenKeyword('action-center')}"
        [attr.title]="isCollapsed ? 'Action Center' : null">
        <img
          [src]="acLink.isActive || isRouteActiveGivenKeyword('action-center') ? 'assets/ac-navbar-active.svg' : 'assets/ac-navbar-inactive.svg'"
          alt="Action Center Icon"
          class="w-6 h-6"
          [ngClass]="isCollapsed ? '' : 'mr-3'"
        />
        <span *ngIf="!isCollapsed" class="font-normal text-sm whitespace-nowrap">Action Center</span>
      </a>

      <!-- Customer Overview (Program Hub) -->
      <a
        *ngIf="canNavigateTo(NavigationMenu.CustomerOverview)"
        data-id="customer-overview"
        routerLink="/customer-overview"
        routerLinkActive
        #coLink="routerLinkActive"
        class="neptune-nav-item flex items-center p-4 text-white hover:bg-white hover:bg-opacity-10 transition-colors cursor-pointer"
        [ngClass]="{'justify-center': isCollapsed, 'neptune-nav-active bg-white text-blue': coLink.isActive || isRouteActiveGivenKeyword('customer')}"
        [attr.title]="isCollapsed ? 'Overview' : null">
        <img
          [src]="coLink.isActive || isRouteActiveGivenKeyword('customer') ? 'assets/program-hub/overview-navbar-active.svg' : 'assets/program-hub/overview-navbar-inactive.svg'"
          alt="Overview Icon"
          class="w-6 h-6"
          [ngClass]="isCollapsed ? '' : 'mr-3'"
        />
        <span *ngIf="!isCollapsed" class="font-normal text-sm whitespace-nowrap">Overview</span>
      </a>
    </div>
  </nav>
